import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './views/app'
import * as Sentry from '@sentry/browser'

const OrderHistoryApp = () => {
  const el = document.getElementById('order-history')

  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn: el.dataset.sentryDsn,
      environment: process.env.NODE_ENV
    })
  }

  const root = createRoot(el)
  root.render(<App />)
  return null
}

export default OrderHistoryApp
